import axios from "axios";

import { config } from "../../config";

export interface AddPartnerDetailsRequest {
  mocaIdJwt: string;
  partnerJwt: string;
  web3AuthJwt: string;
}

export interface CompleteMintRequest {
  partnerJwt?: string;
  web3AuthJwt: string;
  transactionId: string;
  transactionReceipt: string;
}

export interface MocaLoginRequest {
  // email: string;
  // referralCode?: string;
  // walletAddress?: string;
  // signature?: string;
  web3AuthJwt: string;
}
export interface ReserveNameRequest {
  name: string;
  toWallet: string;
  partnerJwt?: string;
  web3AuthJwt: string;

  referralCode?: string;
  walletAddress?: string;
  signature?: string;
  emailConsentAccepted: boolean;
}

class MocaAPIHandler {
  private static mocaAPI = axios.create({
    baseURL: config.mocaIDAPIURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  public static async addPartnerDetails(request: AddPartnerDetailsRequest): Promise<void> {
    const { data } = await this.mocaAPI.post(
      "/api/moca-id/add-partner-details",
      {
        partnerJwt: request.partnerJwt,
        web3AuthJwt: request.web3AuthJwt,
      },
      {
        headers: {
          Authorization: `Bearer ${request.mocaIdJwt}`,
        },
      }
    );
    console.log(data);
  }

  public static async checkEligibility({
    partnerJwt,
    web3AuthJwt,
    jwtToken,
  }: {
    partnerJwt: string;
    web3AuthJwt: string;
    jwtToken: string;
  }): Promise<any> {
    const { data } = await this.mocaAPI.post(
      "/api/moca-id/check-eligibility",
      {
        partnerJwt,
        web3AuthJwt,
      },
      {
        headers: {
          Authorization: jwtToken ? `Bearer ${jwtToken}` : "",
        },
      }
    );
    return data;
  }

  public static async completeMint(request: CompleteMintRequest): Promise<any> {
    const { data } = await this.mocaAPI.post("/api/moca-id/complete-mint", {
      ...request,
    });
    return data;
  }

  public static async containEligibleMoca({ walletAddress }: { walletAddress: string }): Promise<any> {
    const { data } = await this.mocaAPI.get(`/mocas/eligible?walletAddress=${walletAddress}`);
    return data;
  }

  public static async getCurrentUser({ authToken }: { authToken: string }): Promise<any> {
    const { data } = await this.mocaAPI.get("/api/users/me", {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return data;
  }

  public static async getPartnerInfo({ partnerToken }: { partnerToken: string }): Promise<any> {
    const { data } = await this.mocaAPI.get(`/api/partner?partnerJwt=${partnerToken}`);
    return data;
  }

  public static async mocaLogin(request: MocaLoginRequest): Promise<any> {
    const { data } = await this.mocaAPI.post("/auth/login", { ...request });
    return data;
  }

  public static async reserveName({
    reserveNameRequest,
    mocaAuthToken,
  }: {
    reserveNameRequest: ReserveNameRequest;
    mocaAuthToken: string;
  }): Promise<any> {
    const { data } = await this.mocaAPI.post(
      "/api/moca-id/reserve-name",
      {
        ...reserveNameRequest,
      },
      {
        headers: {
          Authorization: `Bearer ${mocaAuthToken}`,
        },
      }
    );
    return data;
  }

  public static async verifyInviteCode({ referralCode }: { referralCode: string }): Promise<any> {
    const { data } = await this.mocaAPI.post("/api/referral-codes/verify", {
      referralCode,
    });
    return data;
  }
}

export default MocaAPIHandler;
